import { createContext, useContext, useEffect, useState } from 'react'
import profileService from 'Services/profileService'
import { EmployeeSingleType } from 'Models/employeeType'
import { useAuth } from 'Components/AuthProvider/AuthProvider'
import { useDispatch } from 'react-redux'
import { USER_ROLE } from 'Constants/MobileMenuConstants'

// context type
interface EmployeeProfileContextType {
  profile: EmployeeSingleType | null
  setProfile: React.Dispatch<React.SetStateAction<EmployeeSingleType | null>>
  refreshProfile: () => Promise<void>
  clearProfile: () => void
}

// create context
const ProfileContext = createContext<EmployeeProfileContextType | undefined>(undefined)

// custom hook with guard
export const useEmployeeProfile = () => {
  const context = useContext(ProfileContext)
  if (!context) {
    throw new Error('useEmployeeProfile must be used within a ProfileProvider')
  }
  return context
}

// provider component
export const ProfileProvider = ({ children }: { children: React.ReactNode }) => {
  const [profile, setProfile] = useState<EmployeeSingleType | null>(null)
  const dispatch = useDispatch()
  const { user, isLocalAuth } = useAuth()
  //   console.log('user', user)

  const getProfile = async () => {
    const response = await profileService.profile()
    const data = response.data.data
    setProfile(data)

    localStorage.setItem('__TG-EMP', JSON.stringify({ ...user, role: data.role }))
    dispatch({ type: USER_ROLE, payload: data.role })
  }

  useEffect(() => {
    if (user && isLocalAuth && !profile) {
      getProfile()
    }
  }, [user, isLocalAuth])

  return (
    <ProfileContext.Provider
      value={{
        profile,
        setProfile,
        refreshProfile: getProfile,
        clearProfile: () => setProfile(null),
      }}
    >
      {children}
    </ProfileContext.Provider>
  )
}
